import { render, staticRenderFns } from "./VerDetalleModal.vue?vue&type=template&id=607b492d&scoped=true&"
import script from "./VerDetalleModal.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleModal.vue?vue&type=script&lang=ts&"
import style0 from "./VerDetalleModal.vue?vue&type=style&index=0&id=607b492d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607b492d",
  null
  
)

export default component.exports